import { Pipe, PipeTransform } from '@angular/core';
import { tableNumberRegex } from '../resources/Constants';

/**
 * This pipe is used to format numbers in a certain way, for example to display a certain number of digits after the comma
 * or points every thousands
 */

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {

    transform(value: string, nDecimals: any): string {
        if (!nDecimals) nDecimals = 2;
        if (!value) {
          return value;
        }



        if (value.indexOf('%') > -1) {
          //  const isPercentAppended: boolean = value.indexOf('%') > 0;
          //  const fvalue = (+(value.replace('%', ''))).toFixed(nDecimals);
          //  return fvalue.toString() + '%';
        const pointPosition = value.indexOf(',');
        const isPercentAppended: boolean = value.indexOf('%') > 0;
            if (isPercentAppended) {
                return (pointPosition === -1) ? value.replace('%', '') + '%' : value.replace('%', '').slice(0, pointPosition + nDecimals + 1) + '%'
            } else {
                return (pointPosition === -1) ? '%' + value.replace('%', '') : '%' + value.replace('%', '').slice(0, pointPosition + nDecimals + 1)
            }
    } else {
      const isNumber = RegExp(tableNumberRegex).test(value);

      if (!isNumber) {
        return value;
      }

      return this.localeString(value, nDecimals);
    }
  }

  /**
   * https://stackoverflow.com/a/49175344 number pipe
   * @param value Number
   */

  localeString(value: string, nDecimals:any) {


      if (value === '') {
         return '';
      }

      let finalValue: string;
      let nBeforeComma: string;
      let nAfterComma: string;
      let regex: RegExp;
      let nBigBeforeComma: string;
      let nBigAfterComma: string[];
      value += '';
      const arrayValue = value.split(',');
      nBeforeComma = arrayValue[0];

      let decimals:string = '';
      decimals = arrayValue.length > 1 ? ',' + arrayValue[1].slice(0, nDecimals? nDecimals : 2) : '';

      decimals = decimals.padEnd(nDecimals? nDecimals + 1 : 3,"0");

      nAfterComma = arrayValue.length > 1 ? decimals : '';
      regex = /(\d+)(\d{3})/;
      while (regex.test(nBeforeComma)) {
        nBeforeComma = nBeforeComma.replace(regex, '$1' + '.' + '$2');
      }

      /**
       * If value was inputed by user, it could have many decimals(up to 7)
       * so we need to reformat previous nBeforeComma results
       */

      if (nBeforeComma.indexOf(',') !== -1) {
        nBigBeforeComma = nBeforeComma.slice(nBeforeComma.lastIndexOf(',')).replace(/\./g, '');

        nBigAfterComma = nBeforeComma.split(',');
        finalValue = nBigAfterComma[0] +  nBigBeforeComma;
      } else {
        finalValue = nBeforeComma + nAfterComma;
      }

      return finalValue;
  }

 


}
